var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cargo-truck 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.648 4.29688H0V11.9733H13.648V4.29688Z",
    fill: "#1D4650"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.0001 9.78813L18.597 6.65039H14.2601V12.5533H9.25834H4.59415H1.64771V13.8952H3.05089C3.03967 13.9715 3.03193 14.0489 3.03193 14.1282C3.03193 14.998 3.73135 15.7031 4.59419 15.7031C5.45703 15.7031 6.15645 14.998 6.15645 14.1282C6.15645 14.0489 6.14872 13.9715 6.1375 13.8952H7.71518C7.70396 13.9715 7.69622 14.0489 7.69622 14.1282C7.69622 14.998 8.39564 15.7031 9.25848 15.7031C10.1212 15.7031 10.8207 14.998 10.8207 14.1282C10.8207 14.0489 10.813 13.9715 10.8018 13.8952H14.2603H14.5671C14.5559 13.9715 14.5482 14.0489 14.5482 14.1282C14.5482 14.998 15.2476 15.7031 16.1104 15.7031C16.9732 15.7031 17.6727 14.998 17.6727 14.1282C17.6727 14.0489 17.665 13.9715 17.6538 13.8952H20.0001V9.78813ZM4.59415 14.7447C4.25642 14.7447 3.98262 14.4687 3.98262 14.1282C3.98262 14.0457 3.99899 13.9671 4.02812 13.8952C4.1193 13.6703 4.3382 13.5117 4.5941 13.5117C4.84999 13.5117 5.06889 13.6703 5.16008 13.8952C5.1892 13.9671 5.20558 14.0457 5.20558 14.1282C5.20562 14.4687 4.93187 14.7447 4.59415 14.7447ZM9.25834 14.7447C8.92061 14.7447 8.64681 14.4687 8.64681 14.1282C8.64681 14.0457 8.66319 13.9671 8.69231 13.8952C8.7835 13.6703 9.0024 13.5117 9.25829 13.5117C9.51419 13.5117 9.73309 13.6703 9.82422 13.8952C9.8534 13.9671 9.86977 14.0457 9.86977 14.1282C9.86982 14.4687 9.59607 14.7447 9.25834 14.7447ZM16.1102 14.7447C15.7725 14.7447 15.4987 14.4687 15.4987 14.1282C15.4987 14.0457 15.5151 13.9671 15.5442 13.8952C15.6354 13.6703 15.8543 13.5117 16.1102 13.5117C16.3661 13.5117 16.585 13.6703 16.6761 13.8952C16.7053 13.9671 16.7216 14.0457 16.7216 14.1282C16.7217 14.4687 16.448 14.7447 16.1102 14.7447ZM15.2927 9.72908C15.2693 9.72908 15.2503 9.71008 15.2503 9.68663V7.5668C15.2503 7.54336 15.2692 7.52435 15.2927 7.52435H17.9625C18.0188 7.52435 18.0697 7.55768 18.0923 7.60929L19.0185 9.72908H15.2927Z",
    fill: "#1D4650"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.371a59de1c6c976407717e95a893a3a5.svg";
export { ForwardRef as ReactComponent };